import { NavLink } from 'react-router-dom';

function AboutHomeProd() {
  return (
    <div className="col-12">
      <div className="col-md-12 mt-5">
        <h3 className="scat_subtitle">Our Home Products</h3>
        <div className="scat_long_desc mb-0">
          <p>
            Welcome to <b>Bakumia.pk</b> — one of the top platforms for{' '}
            <NavLink to="#">
              <b>online shopping in Pakistan</b>
            </NavLink>
            . We offer a wide range of household, kitchen, washroom, and
            daily-use products. You’ll also find accessories for men, women, and
            kids, as well as mobile and computer gadgets to meet your tech
            needs. Our collection features a variety of colors and styles
            designed to match your preferences.
          </p>
          <p>
            Today, shopping online is more convenient than ever — saving time,
            effort, and energy. But choosing the right platform is key.{' '}
            <b>Bakumia.pk</b> is a trusted name for quality and variety. From
            stylish handbags and elegant jewelry to makeup organizers and
            high-heel protectors, we have everything you need. If you're looking
            for{' '}
            <NavLink to="#">
              <b>jewelry online in Pakistan</b>
            </NavLink>
            , explore our unique and antique-inspired designs. Whether you're
            shopping for yourself or someone else, our platform is a reliable
            choice for{' '}
            <NavLink to="#">
              <b>girls’ online shopping</b>
            </NavLink>{' '}
            and more.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutHomeProd;
